module.exports = __webpack_public_path__ + "img/kuwait-finance-house-img.48c31983.png";